import './LmsTecMain.scss';
import * as S from '../scss/theme';
import React, { useState, useEffect } from "react";
import fnc from '../mymod/commFunction';
import Button from '@mui/material/Button';
import Combobox from '../comm/Combobox_noBMK';
import Select from 'react-select';
import LmsTecMainDetail from './LmsTecMainDetail';
import BoardWriteText from './BoardWriteText';
import { useDispatch, useSelector } from 'react-redux';
import { setLessonDate, setIsModal, setLmsListCode } from '../reduxToolkit/redux';



const LmsTecMain = ({kind}) => {


    const dispatch = useDispatch();
   
    const isModal = useSelector((state) => state.reduxStore.isModal);
    const classCode = useSelector((state) => state.reduxStore.classCode);
    const isRefresh_lmsTecList = useSelector((state) => state.reduxStore.isRefresh_lmsTecList);

    const [list, setList] = useState([]);
    const [selectedIdx, setSelectedIdx] = useState(0);
    const [isRefresh, setIsRefresh] = useState(false);
    const [isDetail, setIsDetail] = useState(false);
    const [isModal_write, setIsModal_write] = useState(false);

    const [sno, setSno] = useState(null);
   
    useEffect(() => {
      fncSelect_list();
   
    }, [classCode, isRefresh_lmsTecList]);

    
  function fncSelect_list() {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');
    
    fnc.sendAxios('/select/lmsTec/course/lessonTec', { stCode, classCode, kind }, (res) => {
      if (res && Array.isArray(res)) { 
        setList(getRecords(res));

      } else {
        console.log(res,"select/book/pdfList");
      }
    });
  }

  
  function getRecords(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) {      
        const sno= res[i]["sno"];
        const code= res[i]["code"];//list 코드 parent Code로 사용
        const content = res[i]["content"];
        const fileName = res[i]["fileName"];
        const fileUrl = res[i]["fileUrl"];
        const sDate = res[i]["sDate"];
        const title = res[i]["title"];
        const writer = res[i]["writer"];
             
        records.push({ sno, code, content, fileName, fileUrl, sDate, title, writer });
    }
    return records;
  }

  
  function onClickTr( item, index) {

    setSno(item.sno);
    dispatch(setLessonDate(item.sDate));
    dispatch(setIsModal(true));
    dispatch(setLmsListCode(item.code));
  }

  function onWrite() {
    setIsModal_write(true);
  }
  
  function fncClose() {

    fncSelect_list();
    setIsModal_write(false);
  }

  function isNew(date) {
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    return new Date(date) > oneWeekAgo;
  }

    //=========================================
    return (

      <div className="LmsTecMain">
        <div className="wrap-course-main">
          <section className="section-book-main">
            <table className="table-hong table-gangsa-main">
              <thead>
                <tr>
                  <th>No</th>
                  <th>날짜</th>
                  <th>제목</th>
                  <th>작성자</th>
                </tr>
              </thead>

              <tbody>
                  {list && list.map((item, index) => (
  
                      <tr key={index} onClick={() => onClickTr(item, index)}>  
                        <td>{index+1}</td>
                        <td>{item.sDate}</td>
                        <td>{item.title}
                            {isNew(item.sDate) && <span className="new-label">new</span>}
                        </td>
                        <td>{item.writer}</td>
                      </tr>
                  ))}
            
                </tbody>
            </table>
          </section>
        
       

       
        </div>

        <section className='section-menu'>
          <Button className='btnWrite' onClick={onWrite}>글쓰기</Button>
        </section>

        {isModal && <div className='box_modal'>
                  <LmsTecMainDetail sno={sno} setIsModal={setIsModal}/>
        </div> }   

         {isModal_write && <div className='box_modal'>
                  <BoardWriteText fncClose={fncClose}/>
        </div> }    

       

      </div>
    );
}

export default LmsTecMain;